import styled, { css, RuleSet } from 'styled-components';

const Topic = styled.div<{
  $desktopStyles?: RuleSet<object>;
  $mobileStyles?: RuleSet<object>;
  $palette?: 'yellow' | 'blue' | 'purple';
}>(
  ({ theme, $desktopStyles, $mobileStyles, $palette = 'yellow' }) => css`
    color: ${theme.co.primary20};
    font-family: ${theme.DEPRECATED_ty.openSans};
    font-size: ${theme.DEPRECATED_ty.medium};
    font-weight: ${theme.DEPRECATED_ty.bold};
    line-height: ${theme.DEPRECATED_ty.larger};
    ${$mobileStyles}

    ${
      $palette === 'blue' &&
      css`
        color: ${theme.co.information80};
      `
    }

  ${
      $palette === 'purple' &&
      css`
        color: #bfa3ed; // No alternatives in theme
      `
    }

    @media (min-width: ${theme.sz.md}) {
      font-size: ${theme.DEPRECATED_ty.large};
      line-height: 130%;
      /* or 26px */
      ${$desktopStyles}
    }
  `,
);

export default Topic;
